<template>
  <div class="flex flex-wrap">
    <div class="w-full">

      <!-- Tabs -->
      <div class="relative flex flex-col min-w-0 break-words w-full border border-blueGray-200 rounded-lg mb-3">
        <ul class="flex mb-0 list-none flex-wrap pt-3 pb-4 px-3 flex-row">
          <li class="-mb-px mr-2 last:mr-0" v-for="(tab, i) in tabs" :key="i">
            <a
              class="text-xs px-5 py-3 shadow-lg rounded block leading-normal cursor-pointer"
              :class="openTab === i + 1 ? 'text-white bg-blueGray-900' : 'text-blueGray-600 bg-white'"
              @click="openTab = i + 1"
            >
              <i :class="tab.icon" style="font-size:10px;"></i> {{ tab.label }}
            </a>
          </li>
        </ul>
      </div>

      <!-- Tab content -->
      <div class="relative flex flex-col min-w-0 break-words w-full mb-6">
        <div class="flex-auto">
          <div class="tab-content tab-space">

            <!-- Products -->
            <div :class="{'hidden': openTab !== 1, 'block': openTab === 1}" class="flex flex-wrap">
              <div
                class="w-full px-4"
                :class="{'lg:w-8/12': product !== null, 'lg:w-12/12': product === null}"
              >
                <card-product-lists
                  @init-new-product="handleInitNewProduct"
                  @selectedProduct="(p) => product = p"
                />
              </div>
              <transition name="bounce">
                <div class="w-full lg:w-4/12 px-4" v-if="product !== null">
                  <card-product @close="handleCloseProduct" :selectedProduct="product" />
                </div>
              </transition>
            </div>

            <!-- Orders -->
            <div :class="{'hidden': openTab !== 2, 'block': openTab === 2}">
              <card-orders />
            </div>

            <!-- Carts -->
            <div :class="{'hidden': openTab !== 3, 'block': openTab === 3}">
              <card-carts />
            </div>

            <!-- Wishlist -->
            <div :class="{'hidden': openTab !== 4, 'block': openTab === 4}">
              <card-wishlist />
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import CardProductLists from "@/components/Cards/CardProductLists.vue";
import CardProduct      from "@/components/Cards/CardProduct.vue";
import CardOrders       from "@/components/Cards/CardOrders.vue";
import CardCarts        from "@/components/Cards/CardCarts.vue";
import CardWishlist     from "@/components/Cards/CardWishlist.vue";

export default {
  components: {
    CardProductLists,
    CardProduct,
    CardOrders,
    CardCarts,
    CardWishlist,
  },
  data() {
    return {
      openTab: 1,
      product: null,
      tabs: [
        { label: 'Products',  icon: 'pi pi-barcode'    },
        { label: 'Orders',    icon: 'pi pi-receipt'    },
        { label: 'Carts',     icon: 'pi pi-cart-plus'  },
        { label: 'Wishlist',  icon: 'pi pi-sparkles'   },
      ],
    };
  },
  methods: {
    handleCloseProduct()    { this.product = null; },
    handleInitNewProduct()  { this.product = {};   },
  },
};
</script>
